exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Message */\n.uu5-forms-message {\n  margin-top: 2px;\n  padding: .2em .5em;\n  border-radius: .3em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/internal/message.less
// module id = 324
// module chunks = 0